module.exports = __webpack_public_path__ + "static/media/zhuanpan.d64c6752.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/zhuanpan.png
// module id = 695
// module chunks = 0 1